export const USER='USER';
export const GETUSER='GETUSER';
export const SETUSER='SETUSER';
export const SETLOGO='SETLOGO';
export const SETREDIRECT="SETREDIRECT";
export const SIGNIN = 'SIGNIN'; 
export const SETLOGOACTIVE='SETLOGOACTIVE';
export const AUTHENTICATED = 'AUTHENTICATED';
export const SIGNOUT = 'SIGNOUT';
export const SIGNOUT_SUCCESS = 'SIGNOUT_SUCCESS'
export const SIGNUP = 'SIGNUP';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS'
export const SHOW_AUTH_MESSAGE = 'SHOW_AUTH_MESSAGE'
export const HIDE_AUTH_MESSAGE = 'HIDE_AUTH_MESSAGE'
export const SHOW_LOADING = 'SHOW_LOADING'
export const HIDE_LOADING = 'HIDE_LOADING'
export const AUTH_TOKEN = 'auth_token'
export const SIGNIN_WITH_GOOGLE = 'SIGNIN_WITH_GOOGLE'
export const SIGNIN_WITH_GOOGLE_AUTHENTICATED = 'SIGNIN_WITH_GOOGLE_AUTHENTICATED'
export const SIGNIN_WITH_FACEBOOK = 'SIGNIN_WITH_FACEBOOK'
export const SIGNIN_WITH_FACEBOOK_AUTHENTICATED = 'SIGNIN_WITH_FACEBOOK_AUTHENTICATED'
export const SETLOGOLINK = 'SETLOGOLINK'
export const IS_COMPANY_PAGE = 'IS_COMPANY_PAGE'
export const SCROLL_TO_LIST = 'SCROLL_TO_LIST'
export const COMPANY_SLUG = 'COMPANY_SLUG'
export const JOB_LIST_PAGE_NUMBER = 'JOB_LIST_PAGE_NUMBER'
export const JOB_LIST_PER_PAGE = 'JOB_LIST_PER_PAGE'

